/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import SpecialPropsIndicators from '../props-Indicator/special-props';
import { FormContext } from '../../../shared/contexts/form-context';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import { controlValidate } from '../../../form/utils';
import ImageChoiceOption from './subcomponent';
import {
  MainChoiceWrapper,
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  InputWrapper,
  Field,
} from '../../common-field-styles';

const ImageChoiceTemplate = ({ ctrl, formDesign }) => {
  const [ctrlValidationError, setCtrlValidationError] = useState(ctrl._validationError ?? '');
  const { userCustomTexts, form } = useSelector((state) => state.form);
  const { inBuilder, currentPageNo } = useContext(FormContext);
  const responseStore = form?.response_store ?? 'formplus';
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const dispatch = useDispatch();

  const saveUpdatedCtrl = (newValue, isValid) => {
    dispatch(
      setUserInputOnCtrl({
        newValue,
        property: 'value',
        page: currentPageNo - 1,
        ctrlId: ctrl.internal_id,
        isValid,
      })
    );
  };

  const handleRadioChange = (e) => {
    saveUpdatedCtrl(e.target.value, true);
  };

  useEffect(() => {
    setCtrlValidationError(ctrl._validationError);
  }, [ctrl._validationError]);

  const handleCheckChange = (option) => {
    const newVal = ctrl.value ? [...ctrl.value] : [];
    let newArr = [];
    if (!ctrl.value) {
      newArr = [option];
    } else if (newVal.includes(option)) {
      newArr = newVal.filter((opt) => option !== opt);
    } else newArr = [...newVal, option];
    if (newArr.length < 1) newArr = null;
    const { validationOk } = controlValidate({
      ctrl: { ...cloneDeep(ctrl), value: newArr },
      setCtrlValidationError,
      userCustomTexts,
      responseStore
    });
    saveUpdatedCtrl(newArr, validationOk);
  };

  const handleChange = (e, opt) => {
    if (ctrl.props.rating_type === 'checkbox') {
      handleCheckChange(opt);
    } else {
      handleRadioChange(e);
    }
  };

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          <LabelWrapper
            notInBuilder={!inBuilder}
            required={ctrl.props.required}
            className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
            <SpecialPropsIndicators ctrl={ctrl} />
          </LabelWrapper>

          <InputWrapper className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <MainChoiceWrapper id={`fpl-${ctrl.internal_id}`} className={`${ctrl.props.inline && 'inline'}`}>
              {ctrl.props.options.map((option, optionIndex) => (
                <ImageChoiceOption
                  ctrl={ctrl}
                  key={option}
                  option={option}
                  formDesign={formDesign}
                  optionIndex={optionIndex}
                  handleChange={handleChange}
                />
              ))}
            </MainChoiceWrapper>
            
            <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
              {ctrl.props.subtext}
            </SubtextWrapper>
          </InputWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

ImageChoiceTemplate.defaultProps = {
  formDesign: null,
};

ImageChoiceTemplate.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default ImageChoiceTemplate;
